<template>

    <form-section @submitted="updateTeamName">

        <template #title>

            <font-awesome-icon class="text-blue mr-6 text-xl sm:text-3xl"
                :icon="['far', 'building']">
            </font-awesome-icon>

            <div class="text-lg sm:text-3xl font-nexa text-blue">
                {{ __('Invitation of new users') }}
            </div>

        </template>


        <template #form>

            <div id="form_area" class="col-span-6 grid-cols-1 sm:grid-cols-3 grid-rows-4 sm:grid-rows-2 grid gap-4 sm:gap-8">

                <div style="grid-area: name;">

                    <Label class="text-black text-lg font-nexa mb-2"
                        for="name" :value="__('Company name')" />

                    <Input class="text-black w-full"
                        id="name"
                        type="text"
                        v-model="form.name" />

                    <InputError class="mt-2"
                        :message="form.errors.name" />

                </div>


                <div style="grid-area: invitation_person;">

                    <Label class="text-black text-lg font-nexa mb-2"
                           for="invitation_person" :value="__('Sender of invitation')" />

                    <Input class="text-black w-full"
                           id="invitation_person"
                           type="text"
                           v-model="form.invitation_person" />

                    <InputError class="mt-2"
                                :message="form.errors.invitation_person" />

                </div>


                <div style="grid-area: invitation_message_en;" class="mb-8 sm:mb-0">

                    <Label class="text-black text-lg font-nexa mb-2"
                        for="invitation_message" :value="__('Invitation Message English')" />

                    <Textarea class="text-black w-full"
                        id="invitation_message"
                        style="min-height: 87%;"
                        v-model="form.invitation_message_en" />

                    <InputError class="mt-2"
                        :message="form.errors.invitation_message_en" />

                </div>


                <div style="grid-area: invitation_message_da;">

                    <Label class="text-black text-lg font-nexa mb-2"
                        for="invitation_message" :value="__('Invitation Message Danish')" />

                    <Textarea class="text-black w-full"
                        id="invitation_message"
                        style="min-height: 87%;"
                        v-model="form.invitation_message_da" />

                    <InputError class="mt-2"
                        :message="form.errors.invitation_message_da" />

                </div>

            </div>

        </template>


        <template #actions>

            <Button class="justify-start"
                :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                {{ __('Save changes') }}
            </Button>

            <ActionMessage class="ml-4"
                :on="form.recentlySuccessful"
                type="success">
                {{ __('Saved') }}
            </ActionMessage>

        </template>

    </form-section>

</template>

<script>
    import { defineComponent } from 'vue'
    import ActionMessage from '../../../Components/ActionMessage'
    import Button from '../../../Components/Button'
    import FormSection from '../../../Components/FormSection'
    import Input from '../../../Components/Input'
    import InputError from '../../../Components/InputError'
    import Label from '../../../Components/Label'
    import Textarea from "../../../Components/Textarea";

    export default defineComponent({

        components: {
            Textarea,
            ActionMessage,
            Button,
            FormSection,
            Input,
            InputError,
            Label,
        },


        props: [
            'team',
        ],


        data() {
            return {
                form: this.$inertia.form({
                    name: this.team.name,
                    invitation_person: this.team.invitation_person,
                    invitation_message_en: this.team.invitation_message_en,
                    invitation_message_da: this.team.invitation_message_da
                })
            }
        },


        methods: {
            updateTeamName() {
                this.form.put(route('teams.update', this.team), {
                    errorBag: 'updateTeamName',
                    preserveScroll: true
                });
            },
        },
    })

</script>

<style scoped>

#form_area {
    grid-template-areas:
            "name"
            "invitation_person"
            "invitation_message_en"
            "invitation_message_da";
}

@media (min-width: 640px) {

    #form_area {
        grid-template-areas:
            "name invitation_message_en invitation_message_da"
            "invitation_person invitation_message_en invitation_message_da";
    }

}

</style>
